import {
  UserToUserIdGiftInputModel,
  UserToUserIdGiftPostParams,
} from "../../api/v1/user/[to_user_id]/gift/PostInputModel"
import { postUserToUserIdGift } from "src/api/v1/user/[to_user_id]/gift/post"

export const postGift = async (
  params: UserToUserIdGiftPostParams,
): Promise<void> => {
  const model = new UserToUserIdGiftInputModel(params)
  await postUserToUserIdGift(model)
}
